export function resolveApiBase(apiBase) {
    return apiBase.replace(/\/+$/, '');
}
export function createFingerprint(storageKey) {
    try {
        const cached = window.localStorage.getItem(storageKey);
        if (cached)
            return cached;
    }
    catch {
        // 隐私模式等场景降级内存指纹
    }
    const rand = Math.random().toString(36).slice(2, 10);
    const fp = `w-${Date.now().toString(36)}-${rand}`;
    try {
        window.localStorage.setItem(storageKey, fp);
    }
    catch {
        // ignore
    }
    return fp;
}
export class SupportClient {
    constructor(options) {
        this.options = options;
        this.base = `${resolveApiBase(options.apiBase)}/api/support`;
        this.fingerprintKey = options.fingerprintKey ?? 'dtwince.support.fp';
    }
    async bootstrap() {
        return this.request('/bootstrap');
    }
    async openSession(token) {
        return this.request('/session', {
            method: 'POST',
            body: {
                fingerprint: createFingerprint(this.fingerprintKey),
                source: this.options.source ?? 'site',
                pageUrl: typeof window !== 'undefined' ? window.location.href : undefined,
                supportToken: token,
            },
        });
    }
    async fetchMessages(visitorToken, conversationId, afterId) {
        const query = afterId ? `?afterId=${encodeURIComponent(afterId)}&limit=100` : '?limit=50';
        const res = await this.request(`/conversations/${conversationId}/messages${query}`, { token: visitorToken });
        return res.items ?? [];
    }
    /** 访客已读回执：把 AI/客服消息标记为已读（供客服端显示"已读"） */
    async markRead(visitorToken, conversationId) {
        return this.request(`/conversations/${conversationId}/read`, {
            method: 'POST',
            token: visitorToken,
        });
    }
    async upload(visitorToken, file) {
        const form = new FormData();
        form.append('file', file);
        const res = await fetch(`${this.base}/upload`, {
            method: 'POST',
            headers: { authorization: `Bearer ${visitorToken}` },
            body: form,
        });
        if (!res.ok)
            throw new Error(await readError(res));
        return (await res.json());
    }
    // S15：会话满意度评价（1-5 星）
    async rateConversation(visitorToken, conversationId, score, comment) {
        await this.request(`/conversations/${conversationId}/satisfaction`, {
            method: 'POST',
            token: visitorToken,
            body: { score, comment },
        });
    }
    async request(path, init = {}) {
        const headers = { 'content-type': 'application/json' };
        if (init.token)
            headers.authorization = `Bearer ${init.token}`;
        const res = await fetch(`${this.base}${path}`, {
            method: init.method ?? 'GET',
            headers,
            body: init.body ? JSON.stringify(init.body) : undefined,
        });
        if (!res.ok) {
            // 2026-10-17：携带 HTTP 状态（401 时上层可降级匿名通道）
            const err = new Error(await readError(res));
            err.status = res.status;
            throw err;
        }
        return (await res.json());
    }
}
async function readError(res) {
    // 2026-10-17 修复：429 限流与纯英文异常文案（ThrottlerException: Too Many Requests）本地化，
    // 避免挂件把英文提示直出给用户、并触发浏览器翻译
    if (res.status === 429)
        return '请求过于频繁，请稍后重试';
    try {
        const data = (await res.json());
        const msg = Array.isArray(data.message) ? data.message.join('；') : data.message;
        if (msg && !/[\u4e00-\u9fa5]/.test(msg))
            return `请求失败（${res.status}）`;
        return msg || `请求失败（${res.status}）`;
    }
    catch {
        return `请求失败（${res.status}）`;
    }
}
//# sourceMappingURL=api.js.map